import { Controller } from "react-hook-form";
import { Input } from "../../../../../components/Input";
import React, {FC} from "react";
import {TextArea} from "../../../../../components/TextArea";
import {MAGAZINE_VALUE} from "../../const";

interface Props {
    control: any;
}

const MagazineFields: FC<Props> = ({control}) => {

    return (
        <>
            <Controller
                render={({ field, fieldState }) => {
                    return (
                        <Input
                            placeholder="Наименование печатных изданий"
                            {...field}
                            {...fieldState}
                            ref={null}
                        />
                    );
                }}
                name={`${MAGAZINE_VALUE}.name`}
                control={control}
            />
            <Controller
                render={({ field, fieldState }) => {
                    return (
                        <TextArea
                            placeholder="Комментарий"
                            {...field}
                            {...fieldState}
                            ref={null}
                        />
                    );
                }}
                name={`${MAGAZINE_VALUE}.comment`}
                control={control}
            />
        </>
    );
};

export default MagazineFields;
